export enum DashboardEvents {
    /**
     * Call to change page externally
     */
    ChangeSidePage = 'dashboard.changeSidePage',
    /**
     * Call to change page externally
     */
    ChangeFullPage = 'dashboard.changeFullPage',
    /**
     * Called after page is changed
     */
    SidePageChange = 'dashboard.sidePageChange',
    /**
     * Called after page is changed
     */
    FullPageChange = 'dashboard.fullPageChange',
    DeviceEdited = 'dashboard.deviceEdited',
    /**
     * Called after pin/unpit graph to sensor
     */
    PinUnpinGraph = 'dashboard.pinUnpinGraph',
    UnpinAll = 'dashboard.unpinAll',

    IsFavorite = 'dasboard.isFavorite',
    /**
     * Called after zoom events on graph
     */
    ZoomOut='dasboard.zoomOut',
    ZoomReset='dashboard.zoomReset',
    ZoomedIn='dashboard.zommedIn'
}
